// Cor associada ao grupo de cada status da Ordem de Serviço.
// Usada para chips/badges de status nas telas de lista e detalhe.

const SUCCESS = [
  "COMPLETED",
  "APPROVED",
  "RECEIVED",
  "DELIVERED",
  "DELIVERED_TO_SENDER",
  "DELIVERED_TO_RECEIVER",
  "DELIVERED_TO_SENDER_AND_RECEIVER"
];

const DANGER = [
  "CANCELED",
  "REJECTED",
  "EXPIRED",
  "RETURNED",
  "DELIVERED_TO_SENDER_AND_RECEIVER_AND_RETURNED"
];

const WARNING = [
  "PENDING",
  "WAITING_PAYMENT",
  "WAITING_CLIENT_AUTHORIZATION",
  "ON_HOLD"
];

export const COLORS = {
  success: "#34d399",
  danger: "#fb7185",
  warning: "#fbbf24",
  info: "#2b7bff",
  neutral: "#8a8fab"
};

export const statusColor = (key?: string): string => {
  if (!key) return COLORS.neutral;
  if (SUCCESS.includes(key)) return COLORS.success;
  if (DANGER.includes(key)) return COLORS.danger;
  if (WARNING.includes(key)) return COLORS.warning;
  return COLORS.info;
};
